import React, { useState, useEffect } from 'react';

const useFileDirRow = (FileDirObj, isRenamingFileDir, isDir) => {
	const [isEditing, setIsEditing] = useState(false);
	const [editValue, setEditValue] = useState(FileDirObj.name);

	const handleEdit = (item) => {
		setIsEditing(!isEditing);
		setEditValue(item.name);
	};

	const cancelEdit = () => {
		setIsEditing(false);
		setEditValue(FileDirObj.name);
	};

	useEffect(() => {
		if (isRenamingFileDir) {
			setIsEditing(
				(isDir
					? FileDirObj?.vv_dir_id === isRenamingFileDir?.vv_dir_id
					: FileDirObj?.vv_file_id ===
					  isRenamingFileDir?.vv_file_id) || false,
			);
		}
	}, [isRenamingFileDir]);

	return {
		handleEdit,
		cancelEdit,
		editValue,
		setEditValue,
		isEditing,
		setIsEditing,
	};
};

export default useFileDirRow;
